import React from 'react';
import Link from 'next/link';
import FaqGroup from 'components/FaqGroup';
import FaqItem from 'components/FaqItem';
import Layout1x1 from 'components/Layout1x1';
import NextSteps from 'components/NextSteps';
import SalesCalloutHTO from 'components/SalesCalloutHTO';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import Line from 'components/Line';
import { withPageStaticProps } from 'utils/header';

class COVID extends React.Component {
  render() {
    return (
      <>
        <Layout1x1 className="m-section-hero">
          <h1 className="text-h1">COVID-19 Business Update</h1>

          <Line />

          <p>
            In accordance with the request of the CDC, we at Menguin are taking steps to protect the safety of our employees and the
            community, as well as serve our customers and maintain the business while we modify our business to work through the current
            COVID-19 situation. The information below will help you modify your plans and ensure your suit or tuxedo is ready for your
            wedding or event.
          </p>

          <h2 className="text-h3">DON’T CANCEL. YOU CAN RESCHEDULE OR POSTPONE YOUR EVENT DATE</h2>

          <p>
            We know this is a stressful time full of uncertainty around your wedding and the gathering of your friends and family. We want
            to be one less thing to worry about right now. Don’t cancel your rental, simply postpone. There will be no additional charges or
            fees to reschedule or postpone your event. To change your event date, simply{' '}
            <Link href="/app/account/login" className="tracker-text-covid-log_in-20200324-144006">
              log into your account
            </Link>{' '}
            and update your information. You will also need to contact your wedding party to communicate changes and new event details as
            you are the event owner.
          </p>

          <p>
            If you are a member of an event (EX: groomsmen, father of the bride or groom, etc) and cannot attend and need to cancel, please
            contact customer service so we can confirm details with the event owner and process any refunds required. Please be patient as
            all changes to any event member status must be confirmed with the event owner.
          </p>

          <h2 className="text-h3">RENT FAST, WITH CONFIDENCE</h2>

          <p>
            Our distribution center is open and working to get everyone their suit or tuxedo for their event. If you need an outfit fast,
            we’re here to help. Contact a member of our{' '}
            <Link href="/support" className="tracker-text-covid-cx_team-20210928-141647">
              customer experience team
            </Link>{' '}
            if you have any questions or concerns.
          </p>

          <p>
            You may have questions about our cleaning and sanitization process . All of our items are professionally cleaned in-house at our
            Louisville, Kentucky location. Each item is manually inspected and placed into a specific cleaning process dedicated to its
            material fibers.
          </p>

          <h2 className="text-h3">IF YOU HAVE TO CANCEL</h2>

          <p>
            If there are circumstances out of your control and you must cancel, we understand. During this time we have limited resources
            working and it will take time to process refunds. The good news, things may change by then and you can simply change your
            cancellation to a reschedule and keep your rental. Please note, if you have not cancelled your order within 3 weeks of your
            event date there will be a $40 shipping and restocking fee.
          </p>

          <FaqGroup title="FAQ’s">
            <FaqItem
              question="If I don’t know my event date and want to postpone, what do I do?"
              trackerClass="tracker-btn-covid19-postponement_how-220117-144838"
            >
              <p>
                We can set a temporary date of 12/31/21 until you have a rescheduled date. This will hold all shipment and event details for
                you.
              </p>
            </FaqItem>

            <FaqItem
              question="I want to postpone, but I’m having trouble making the change in my account"
              trackerClass="tracker-btn-covid19-postponement_help-220117-144838"
            >
              <p>
                Please contact our{' '}
                <Link
                  href="mailto:&#115;&#101;&#114;&#118;&#105;&#099;&#101;&#064;&#109;&#101;&#110;&#103;&#117;&#105;&#110;&#046;&#099;&#111;&#109;"
                  className="tracker-text-covid-cx-20200324-144218"
                >
                  customer experience team
                </Link>{' '}
                and we can manually change your event date for you.
              </p>
            </FaqItem>

            <FaqItem
              question="If I want to postpone now, but end up cancelling can I get a refund?"
              trackerClass="tracker-btn-covid19-postponement_refund-220117-144838"
            >
              <p>
                Yes, we can set a temporary date of 12/31/21 until you get back to us. If you ultimately have to cancel we will issue a
                refund to you. Please note, at the request of the CDC most of our call center and payment processing are working remote,
                with extremely limited staff in the office. We’re actively working on solutions to the new working environment and will
                process refunds as quickly as we can. Thank you in advance for your patience.
              </p>
            </FaqItem>

            <FaqItem question="Are you still shipping orders?" trackerClass="tracker-btn-covid19-still_shipping-220117-144838">
              <p>Yes, we will ship orders as long as the state of Kentucky allows.</p>
            </FaqItem>
          </FaqGroup>
        </Layout1x1>
        <div className="bg-gray-lighter">
          <NextSteps
            ctaPageName="covid"
            salesCallout1={<SalesCalloutHTO ctaPageName="covid" />}
            salesCallout2={<SalesCalloutSwatches ctaPageName="covid" />}
          />
        </div>
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default COVID;
